import { render, staticRenderFns } from "./IQAskAnythingHeader.vue?vue&type=template&id=39fda490&scoped=true"
import script from "./IQAskAnythingHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./IQAskAnythingHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQAskAnythingHeader.vue?vue&type=style&index=0&id=39fda490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fda490",
  null
  
)

export default component.exports